export const SHOW_APP_ACTION = 'SHOW_APP_ACTION'
export const SHOW_APP_MUTATION = 'SHOW_APP_MUTATION'

export const LOGIN_ACTION = 'LOGIN_ACTION'
export const LOGIN_MUTATION = 'LOGIN_MUTATION'
export const LOGOUT_ACTION = 'LOGOUT_ACTION'
export const LOGOUT_MUTATION = 'LOGOUT_MUTATION'

export const SET_INIT_DATA_MUTATION = 'SET_INIT_DATA_MUTATION'
export const SET_INIT_DATA_ACTION = 'SET_INIT_DATA_ACTION'

export const ADD_TO_TEST_DEFINITION_CACHE_ACTION = 'ADD_TO_TEST_DEFINITION_CACHE_ACTION'
export const ADD_TO_TEST_DEFINITION_CACHE_MUTATION = 'ADD_TO_TEST_DEFINITION_CACHE_MUTATION'

export const RESET_STATE_ACTION = 'RESET_STATE_ACTION'
export const RESET_STATE_MUTATION = 'RESET_STATE_MUTATION'

export const SET_REQUESTED_BY_DOCTORS_ACTION = 'SET_REQUESTED_BY_DOCTORS_ACTION'
export const SET_REQUESTED_BY_DOCTORS_MUTATION = 'SET_REQUESTED_BY_DOCTORS_MUTATION'
export const SET_COLLECTION_CENTERS_ACTION = 'SET_COLLECTION_CENTERS_ACTION'
export const SET_COLLECTION_CENTERS_MUTATION = 'SET_COLLECTION_CENTERS_MUTATION'